/* eslint-disable no-loop-func */
import React, { useEffect, useRef, useState } from "react";
import { toast } from "../../components/ui/use-toast";
import * as XLSX from "xlsx";
import cellEditFactory from "react-bootstrap-table2-editor";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import Spin from "../../components/Spin";
import {
  API,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "../../components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";
import FileUpload from "../../components/FileUpload";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import { getModuleNamingBySlug } from "../../lib/Misc";
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from "../../components/ui/dropdown-menu";
import CombineAssetHubImport from "../CombineAssetHubImport";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";

const UploadAsset = ({
  fetchData,
  trustId,
  ButtonName,
  setLoading,
  organizationData,
}) => {
  const [showImport, setShowImport] = useState(false);
  const [showCombineImport, setShowCombineImport] = useState(false);

  const [files, setFiles] = useState([]);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelAssetData, setExcelAssetData] = useState();
  const [isImportLoading, setIsImportLoading] = useState(false);

  const handleDownload = async (sample) => {
    try {
      setLoading(true);
      let api = sample
        ? `${API.DOWNLOAD_ASSET_TEMPLATE}?sample=${sample}&trust_id=${
            trustId ? trustId : ""
          }`
        : `${API.EXPORT_ASSET}?trust_id=${trustId ? trustId : ""}`;
      const { data } = await get(api);
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        // ✅ ADD THIS LINE FOR SAFARI
        a.setAttribute("target", "_blank");
        a.setAttribute("download", file[file.length - 1] || "contractor.xls");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleCombineDownload = async (option) => {
    try {
      setLoading(true);
      let api = `${API.DOWNLOAD_COMBINE_ASSET_TEMPLATE}?trust_id=${
        trustId ? trustId : ""
      }&options=${option}`;

      const { data } = await get(api);
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "contractor.xls");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  // const handleImportModal = async () => {
  //   setShowImport(!showImport);
  // };

  const handleCombineImportModal = async () => {
    setShowCombineImport(!showCombineImport);
  };

  const handleExcelClose = () => {
    setExcelSelectedRow([]);
    setShowExcelModal(false);
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleImportClose = () => {
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleClose = () => {
    setFiles([]);
  };

  const ExcelAssetColumns = [
    {
      headerClasses: THClasses,
      dataField: "vendor_code",
      text: (
        <div>
          <span className="required">*</span>
          {getModuleNamingBySlug(
            organizationData?.organizationData,
            "vendors",
            "Vendor",
          )}{" "}
          Code
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "vendors",
              "Vendor",
            )} is Required`,
          };
        }
        return true;
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "code",
      text: (
        <div>
          {getModuleNamingBySlug(
            organizationData?.organizationData,
            "assets",
            "Asset",
          )}{" "}
          Code
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "name",
      text: (
        <div>
          <span className="required">*</span>
          {getModuleNamingBySlug(
            organizationData?.organizationData,
            "assets",
            "Asset",
          )}{" "}
          Name
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "assets",
              "Asset",
            )} Name is Required`,
          };
        }
        return true;
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "estimated_value",
      text: "Estimated Value",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
      validator: (newValue) => {
        if (newValue) {
          if (!/^[0-9,]*\.?[0-9,]*$/.test(newValue)) {
            return {
              valid: false,
              message:
                "Only digits, commas (,) are allowed, with at most one dot (.)",
            };
          }
        }
        return true; // If valid, return true
      },
    },
    {
      headerClasses: THClasses,
      dataField: "street",
      text: "Street",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(newValue)) {
            return {
              valid: false,
              message:
                "Street name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-), parentheses(), slashes(/) & spaces.", // Display the error message when validation fails
            };
          }
        }
        return true; // If valid, return true
      },

      // Optionally add CSS classes for invalid input (e.g., to highlight the field in red)
      classes: (cell) => {
        if (cell && !/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(cell)) {
          return `${TDClasses} text-red-500`; // Apply error styling
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "suburb",
      text: "Suburb",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "state",
      text: "State",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "postal_code",
      text: "Postal Code",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!newValue.match(/^[\d]{4}$/)) {
            return {
              valid: false,
              message: "Postal Code can contain 4 digit numbers.",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (!String(cell).match(/^[\d]{4}$/)) {
            return `${TDClasses} text-red-500`;
          }
        }
        return TDClasses;
      },
    },
  ];

  const [excelSelectedRow, setExcelSelectedRow] = useState([]);

  let singleExcelSelectedRows = [];
  let allExcelSelectedRows = [];

  const excelSelectRow = {
    mode: "checkbox",
    clickToSelect: false,
    classes: "selection-row",
    nonSelectable: ["not-select"],
    selected: excelSelectedRow,
    nonSelectableClasses: "not-selected-class",
    onSelect: (row, isSelect, rowIndex, e) => {
      singleExcelSelectedRows = [...excelSelectedRow];
      if (isSelect) {
        singleExcelSelectedRows = [...excelSelectedRow, row?.key];
      } else {
        singleExcelSelectedRows.splice(excelSelectedRow.indexOf(row?.key), 1);
      }
      setExcelSelectedRow(singleExcelSelectedRows);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (let i = 0; i < rows.length; i++) {
          if (excelSelectedRow.includes(rows[i].key)) {
          } else {
            allExcelSelectedRows.push(rows[i].key);
          }
        }
      } else {
        for (let i = 0; i < rows.length; i++) {
          if (excelSelectedRow.includes(rows[i].key)) {
            excelSelectedRow.splice(excelSelectedRow.indexOf(rows[i].key), 1);
          }
        }
      }
      setExcelSelectedRow([...excelSelectedRow, ...allExcelSelectedRows]);
    },
  };

  const excelRef = useRef();

  const ExcelReader = () => {
    let f = files[0];
    const reader = new FileReader();
    let data = null;
    reader.onload = async (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      data = await XLSX.utils.sheet_to_json(ws, { header: 1 });
      /* Update state */
      let selectItem = [];
      const businessExcelGenerator = (quantity) => {
        const items = [];
        if (
          String(data[0][0]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "vendors",
              "Vendor",
            )} Code` ||
          String(data[0][1]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "assets",
              "Asset",
            )} Code` ||
          String(data[0][2]).replace("*", "") !==
            `${getModuleNamingBySlug(
              organizationData?.organizationData,
              "assets",
              "Asset",
            )} Name` ||
          String(data[0][3]).replace("*", "") !== "Estimated Value" ||
          String(data[0][4]).replace("*", "") !== "Street" ||
          String(data[0][5]).replace("*", "") !== "Suburb" ||
          String(data[0][6]).replace("*", "") !== "State" ||
          String(data[0][7]).replace("*", "") !== "Postal Code"
        ) {
          setShowExcelModal(false);
          setFiles();
          setIsImportLoading(false);
          toast({
            variant: "destructive",
            description:
              "Sorry, File is not in the given format, please download the latest format again",
            duration: 3000,
          });
        } else {
          for (let i = 1; i < quantity; i++) {
            if (data[i].length > 0) {
              selectItem.push(i);
              items.push({
                key: i,
                vendor_code: data[i][0] ? data[i][0] : "",
                code: data[i][1] ? data[i][1] : "",
                name: data[i][2] ? data[i][2] : "",
                estimated_value: data[i][3] ? data[i][3] : "",
                street: data[i][4] ? data[i][4] : "",
                suburb: data[i][5] ? data[i][5] : "",
                state: data[i][6] ? data[i][6] : "",
                postal_code: data[i][7] ? data[i][7] : "",
              });
            }
          }
        }
        return items;
      };
      setExcelSelectedRow(selectItem);
      setExcelAssetData(businessExcelGenerator(data?.length));
    };
    reader.readAsBinaryString(f);
  };

  useEffect(() => {
    showExcelModal && ExcelReader();
    // eslint-disable-next-line
  }, [showExcelModal]);

  const handleExcelModal = () => {
    setShowExcelModal(true);
  };

  const handleUpload = async () => {
    if (excelSelectedRow.length > 1000) {
      toast({
        description: "Maximum limit to import assets is 1000",
        duration: 3000,
      });
    } else {
      // if (files) {
      setShowExcelModal(true);
      const formData = new FormData();

      formData.append("trust_id", trustId);

      for (let i = 0; i < excelSelectedRow.length; i++) {
        let row = excelAssetData.find(
          (item) => item.key === excelSelectedRow[i],
        );
        // formData.append(`assets[${i}]`, JSON.stringify(row));
        Object.keys(row).forEach((key) => {
          formData.append(`assets[${i}][${key}]`, row[key]);
        });
      }

      const config = { headers: { "Content-Type": "multipart/form-data" } };
      try {
        setIsImportLoading(true);
        const { data } = await fileUpload(
          `${API.IMPORT_ASSET}`,
          formData,
          config,
        );
        setIsImportLoading(false);
        if (data) {
          setExcelSelectedRow([]);
          handleExcelClose();
          fetchData();
          handleImportClose();
          if (data?.data?.file) {
            const export_report_path = data?.data?.file;
            if (export_report_path) {
              var a = document.createElement("a");
              a.href = export_report_path;
              var file = export_report_path.split("/");
              a.setAttribute(
                "download",
                file[file.length - 1] || "error-subcontractor.xls",
              );
              a.setAttribute("target", "_blank");
              document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
              a.click();
              a.remove();
              setLoading(false);
            }
          }
        }
        return data?.data;
      } catch (error) {
        if (error?.response?.data?.errors) {
          if (error?.response?.data?.errors?.data?.file) {
            const export_report_path =
              error?.response?.data?.errors?.data?.file;
            if (export_report_path) {
              // eslint-disable-next-line no-redeclare
              var a = document.createElement("a");
              a.href = export_report_path;
              // eslint-disable-next-line no-redeclare
              var file = export_report_path.split("/");
              a.setAttribute(
                "download",
                file[file.length - 1] || "error-sub-contractor.xls",
              );
              a.setAttribute("target", "_blank");
              document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
              a.click();
              a.remove();
              setLoading(false);
            }
          }
          fetchData();
          setIsImportLoading(false);
        } else {
          setIsImportLoading(false);
        }
      }
      // }
    }
  };

  const handleExcelTableChange = async (
    type,
    { data, cellEdit: { rowId, dataField, newValue } },
  ) => {
    const getWithPromiseAll = async () => {
      let temp = await Promise.all(
        data.map(async (row) => {
          if (row?.key === rowId) {
            const newRow = { ...row };

            newRow[dataField] = newValue;

            return newRow;
          }
          return row;
        }),
      );
      return temp;
    };
    const result = await getWithPromiseAll();
    setExcelAssetData(result);
  };
  return (
    <>
      <AnimatedTooltip title={"Export"}>
        <Button
          onClick={() => handleDownload(0)}
          className="flex gap-2 items-center"
        >
          Export <Download size={18} />
        </Button>
      </AnimatedTooltip>
      <div className="flex bg-webPrimary rounded-md">
        <AnimatedTooltip
          title={`Import ${getModuleNamingBySlug(
            organizationData?.organizationData,
            "assets",
            "Asset",
          )}`}
        >
          <Button
            className="bg-transparent flex items-center gap-1 px-2"
            onClick={handleCombineImportModal}
          >
            <FileSpreadsheet size={18} />
            {ButtonName}
          </Button>
          {/* <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button className="bg-transparent flex items-center gap-1 px-2">
                <FileSpreadsheet size={18} />
                {ButtonName}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={handleImportModal}>
                Single Import
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleCombineImportModal}>
                <div>
                  <div className="flex flex-col">
                    <div>Combine Import</div>
                    <div className="text-xs text-webPrimary">
                      {`(${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor"
                      )}, ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "assets",
                        "Asset"
                      )}, ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "sub-assets",
                        "Sub Asest"
                      )})`}
                    </div>{" "}
                  </div>
                </div>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu> */}
        </AnimatedTooltip>
        <AnimatedTooltip title={"Download Template"}>
          {/* <Button
            className="bg-transparent border-l border-white dark:border-black rounded-none px-2 rounded-se-md rounded-ee-md"
            onClick={() => handleCombineDownload()}
          >
            <Download size={18} />
          </Button> */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button className="bg-transparent border-l border-white dark:border-black rounded-none px-2 rounded-se-md rounded-ee-md">
                <Download size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => handleCombineDownload(2)}>
                Asset Template
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleCombineDownload(3)}>
                <div>
                  <div className="flex flex-col">
                    <div>Combine Template</div>
                    <div className="text-xs text-webPrimary">
                      {`(${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor",
                      )}, ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "assets",
                        "Asset",
                      )})`}
                    </div>{" "}
                  </div>
                </div>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </AnimatedTooltip>
      </div>
      <ResponsiveDrawerForm
        description={""}
        title={`Import ${getModuleNamingBySlug(
          organizationData?.organizationData,
          "assets",
          "Assets",
        )}`}
        handleOpen={() => {}}
        handleClose={() => {
          handleClose();
        }}
        className={"sm:max-w-1/2"}
        open={showImport}
        buttonClassName={""}
        setOpen={setShowImport}
        mobileCancelHidden={true}
        write={true}
      >
        <>
          <FileUpload
            files={files}
            setFiles={setFiles}
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
          />

          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button
              type="submit"
              onClick={(e) => {
                handleExcelModal();
              }}
              disabled={files?.length === 0}
            >
              Upload
            </Button>
            <Button
              className="reset ml-3"
              data-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                handleImportClose();
              }}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </>
      </ResponsiveDrawerForm>
      <ResponsiveDrawerForm
        description={""}
        title={"Upload Excel"}
        handleOpen={() => {}}
        handleClose={() => {}}
        className={"max:min-w-screen"}
        open={showExcelModal}
        buttonClassName={""}
        setOpen={setShowExcelModal}
        write={true}
      >
        <div className="overflow-y-auto overflow-x-hidden max-h-[85vh] md:p-0 p-4">
          {isImportLoading && <Spin full expand={true} fullscreen={true} />}
          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              selectRow={excelSelectRow}
              ref={excelRef}
              remote={{ cellEdit: true }}
              data={excelAssetData ? excelAssetData : []}
              columns={ExcelAssetColumns}
              noDataIndication="No Data Found"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                timeToCloseMessage: 30000,
              })}
              onTableChange={handleExcelTableChange}
              rowClasses={TRClasses}
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>
          <div className="pt-4 border-t mt-4 flex items-center justify-between">
            <div>Selected Records: {excelSelectedRow?.length}</div>
            <Button
              onClick={handleUpload}
              data-toggle="modal"
              data-target="#business"
              disabled={excelSelectedRow.length === 0 ? true : false}
            >
              Import
            </Button>
          </div>
        </div>
      </ResponsiveDrawerForm>

      <ResponsiveDrawerForm
        description={""}
        title={`Import`}
        handleOpen={() => {}}
        handleClose={() => {
          handleClose();
        }}
        className={"sm:max-w-1/2"}
        open={showCombineImport}
        buttonClassName={""}
        setOpen={setShowCombineImport}
        mobileCancelHidden={true}
        write={true}
      >
        <>
          <CombineAssetHubImport
            fetchData={fetchData}
            setShowCombineImport={setShowCombineImport}
            trustId={trustId}
            setLoading={setLoading}
          />
        </>
      </ResponsiveDrawerForm>
    </>
  );
};

export default UploadAsset;
